import { render, staticRenderFns } from "./ProxyTable.vue?vue&type=template&id=70472c3b&"
import script from "./ProxyTable.vue?vue&type=script&lang=js&"
export * from "./ProxyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports